import { render, staticRenderFns } from "./UpdateUserGroupModal.vue?vue&type=template&id=01c6f40b&"
import script from "./UpdateUserGroupModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUserGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateUserGroupModal.vue?vue&type=style&index=0&id=01c6f40b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports